<template>
    <form-wrapper @submit="handleFormSubmission(data)">
        <form-row>
            <form-cell>
                <text-field
                    :label="$t('forms.auth.reset_password.fields.password.label')"
                    :placeholder="$t('forms.auth.reset_password.fields.password.placeholder')"
                    :hasAutofocus="true"
                    :error="inviteError"
                    :isRequired="true"
                    :formData="data"
                    valuePath="password"
                    :type="passwordInputFieldType"
                    :maxLength="40"
                    @change="change($event)"
                >
                    <template v-if="inviteError" #error>
                        <p class="">
                            {{ $t('pages.auth.reset_password.token_expired') }}
                            <span class="error-button" @click="sendReminder()">
                                <u>{{ $t('pages.auth.reset_password.token_expired_here') }}</u>
                            </span>
                            {{ $t('pages.auth.reset_password.token_expired_resend') }}
                        </p>
                    </template>
                    <template #icon>
                        <common-toggle-visibility-button
                            @visibility-toggle-switch="showPassword"
                        ></common-toggle-visibility-button>
                    </template>
                </text-field>
            </form-cell>
        </form-row>

        <form-row>
            <form-cell>
                <text-field
                    v-if="!shouldShowPassword"
                    :label="$t('forms.auth.reset_password.fields.confirm_password.label')"
                    :isRequired="true"
                    :formData="data"
                    valuePath="confirmPassword"
                    type="password"
                    @change="change($event)"
                ></text-field>
            </form-cell>
        </form-row>

        <form-row>
            <form-cell>
                <checkbox-field :formData="data" valuePath="agree" @change="change($event)">
                    <template #label>
                        <span v-html="$t('forms.auth.register.fields.agree.label')"></span>
                    </template>
                </checkbox-field>
            </form-cell>
        </form-row>

        <template #footer>
            <common-buttons>
                <common-button
                    :isProcessing="isSending"
                    :label="$t('forms.auth.reset_password.microcopy.reset_password')"
                    :isDisabled="!data.agree"
                    type="primary"
                ></common-button>
            </common-buttons>
        </template>
    </form-wrapper>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import AuthAPI from 'api/AuthAPI'
    import PasswordToggleVisibilityMixin from 'mixins/PasswordToggleVisibilityMixin'

    export default {
        mixins: [FormMixin, PasswordToggleVisibilityMixin],

        data() {
            return {
                inviteError: '',
                notificationMessage: '',
            }
        },

        methods: {
            handleFormSubmission(data) {
                this.handleRequest(AuthAPI.setPassword(this.$route.query.e, data.password, this.$route.query.c))
                    .then(() => this.emitEvent({ name: 'sent' }))
                    .catch(() => {
                        this.data.password = ''
                        this.data.confirmPassword = ''
                        this.inviteError = 'error'
                        this.isSending = false
                    })
            },

            sendReminder() {
                this.inviteError = ''
                this.handleRequest(AuthAPI.forgotPassword(this.$route.query.e)).then(() => {
                    this.isSending = false
                    this.$router.push({ name: 'auth.login', query: { verified: 'email_sent' } })
                })
            },
        },
    }
</script>

<style scoped lang="scss">
    .error-button {
        cursor: pointer;
    }
</style>
